import { NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GhostConsoleComponent } from './ghost-console.component';
import { FormsModule } from '@angular/forms';
import { AppNgMaterialModule } from '../app-ng-material.module';
import { AppNgAppkitModule } from '../app-ng-appkit.module';
import { PaginationWrapperModule } from '../shared/components/pagination-wrapper/pagination-wrapper.module';
import { GhostConsoleRoutingModule } from './ghost-console-routing.module';

@NgModule({
  declarations: [GhostConsoleComponent],
  imports: [
    CommonModule,
    FormsModule,
    AppNgMaterialModule,
    AppNgAppkitModule,
    PaginationWrapperModule,
    GhostConsoleRoutingModule,
  ],
  exports: [GhostConsoleComponent],
  schemas: [NO_ERRORS_SCHEMA]
})
export class GhostConsoleModule { }
